// Cookie-Consent-Speicher + Google-Analytics-Loader.
// GA wird ausschließlich nach erteilter Statistik-Einwilligung geladen (DSGVO/TTDSG-konform).

const CONSENT_KEY = "ks_cookie_consent";
export const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export function getConsent() {
  try {
    return JSON.parse(localStorage.getItem(CONSENT_KEY));
  } catch {
    return null;
  }
}

export function saveConsent(consent) {
  localStorage.setItem(
    CONSENT_KEY,
    JSON.stringify({ ...consent, necessary: true, ts: new Date().toISOString(), v: 1 })
  );
}

export function statisticsAllowed() {
  const consent = getConsent();
  return Boolean(GA_ID && consent && consent.statistics);
}

let gaLoaded = false;

// Laedt gtag.js dynamisch nach und konfiguriert GA4 (IP-Anonymisierung aktiv).
export function ensureAnalytics() {
  if (!statisticsAllowed() || gaLoaded) return;
  gaLoaded = true;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { anonymize_ip: true, send_page_view: false });
}

// SPA-Pageview bei jedem Routenwechsel – nur wenn GA geladen und erlaubt.
export function trackPageView(path) {
  if (!statisticsAllowed() || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
  });
}
